import { colorTokens } from '../../tokens/globals/tokens';
import { colorTokens as coreColorTokens } from '../../tokens/core/tokens';

const colors = {
  'blue-lightest': colorTokens.GlobalBrandBlue30,
  'blue-light': colorTokens.GlobalBrandBlue40,
  blue: colorTokens.GlobalBrandBlue60,
  'blue-dark': colorTokens.GlobalBrandBlue70,
  'blue-darkest': colorTokens.GlobalBrandBlue80,
  'green-lightest': colorTokens.GlobalBrandGreen30,
  'green-light': colorTokens.GlobalBrandGreen50,
  green: colorTokens.GlobalBrandGreen60,
  'green-dark': colorTokens.GlobalBrandGreen70,
  'green-darkest': colorTokens.GlobalBrandGreen80,
  'yellow-lightest': colorTokens.GlobalBrandYellow30,
  'yellow-light': colorTokens.GlobalBrandYellow40,
  yellow: colorTokens.GlobalBrandYellow50,
  'yellow-dark': colorTokens.GlobalBrandYellow60,
  'yellow-darkest': colorTokens.GlobalBrandYellow70,
  'orange-lightest': colorTokens.GlobalBrandOrange30,
  'orange-light': colorTokens.GlobalBrandOrange40,
  orange: colorTokens.GlobalBrandOrange50,
  'orange-dark': colorTokens.GlobalBrandOrange60,
  'orange-darkest': colorTokens.GlobalBrandOrange80,
  'red-lightest': colorTokens.GlobalBrandRed30,
  'red-light': colorTokens.GlobalBrandRed40,
  red: colorTokens.GlobalBrandRed50,
  'red-dark': colorTokens.GlobalBrandRed60,
  'red-darkest': colorTokens.GlobalBrandRed70,
  'pink-lightest': coreColorTokens.CoreLegacyPinkLightest,
  'pink-light': coreColorTokens.CoreLegacyPinkLight,
  pink: coreColorTokens.CoreLegacyPinkBase,
  'pink-dark': coreColorTokens.CoreLegacyPinkDark,
  'pink-darkest': coreColorTokens.CoreLegacyPinkDarkest,
  'purple-lightest': coreColorTokens.CoreLegacyPurpleLightest,
  'purple-light': coreColorTokens.CoreLegacyPurpleLight,
  purple: coreColorTokens.CoreLegacyPurpleBase,
  'purple-dark': coreColorTokens.CoreLegacyPurpleDark,
  'purple-darkest': coreColorTokens.CoreLegacyPurpleDarkest,
  'slate-lightest-1': coreColorTokens.CoreLegacySlateLightest1,
  'slate-lightest-2': coreColorTokens.CoreLegacySlateLightest2,
  'slate-lightest-3': coreColorTokens.CoreLegacySlateLightest3,
  'slate-light-1': coreColorTokens.CoreLegacySlateLight1,
  'slate-light-2': coreColorTokens.CoreLegacySlateLight2,
  'slate-light-3': coreColorTokens.CoreLegacySlateLight3,
  slate: coreColorTokens.CoreLegacySlateBase,
  'slate-dark-1': coreColorTokens.CoreLegacySlateDark1,
  'slate-dark-2': coreColorTokens.CoreLegacySlateDark2,
  'slate-dark-3': coreColorTokens.CoreLegacySlateDark3,
  'gray-lightest-1': colorTokens.GlobalBrandGray10,
  'gray-lightest-2': colorTokens.GlobalBrandGray10,
  'gray-lightest-3': colorTokens.GlobalBrandGray20,
  'gray-light-1': colorTokens.GlobalBrandGray30,
  'gray-light-2': colorTokens.GlobalBrandGray40,
  'gray-light-3': colorTokens.GlobalBrandGray50,
  gray: colorTokens.GlobalBrandGray60,
  'gray-dark-1': colorTokens.GlobalBrandGray70,
  'gray-dark-2': colorTokens.GlobalBrandGray80,
  'gray-dark-3': colorTokens.GlobalBrandGray90,
  white: colorTokens.GlobalBrandWhite,
  black: colorTokens.GlobalBrandBlack,
  transparent: coreColorTokens.CoreLegacyTransparent,
  'shadow-color': 'rgba(0, 0, 0, .08)',
  staff: colorTokens.GlobalBrandOrange60,
  'key-pair': colorTokens.GlobalBrandBrown10,
} as const;

export type Color = keyof typeof colors;

export default colors;
